import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    className: { type: String, default: "is-dismissing" },
    delay: { type: Number, default: 5000 },
    duration: { type: Number, default: 220 },
    remove: { type: Boolean, default: true }
  }

  connect() {
    this.dismissed = false

    if (this.delayValue >= 0) {
      this.dismissTimer = window.setTimeout(() => this.dismiss(), this.delayValue)
    }
  }

  disconnect() {
    window.clearTimeout(this.dismissTimer)
    window.clearTimeout(this.removeTimer)
  }

  dismiss(event) {
    event?.preventDefault()

    if (this.dismissed) return

    this.dismissed = true
    window.clearTimeout(this.dismissTimer)
    this.element.classList.add(this.classNameValue)

    if (this.removeValue) {
      this.removeTimer = window.setTimeout(() => this.element.remove(), this.durationValue)
    }
  }
}
